import axiosInstance from '@/services/axiosInstance'
import mock from '@/services/mock/index'

async function cambiarestadodiligencias (payload = {}) {
  if (process.env.VUE_APP_ENVIRONMENT === 'test') {
    return new Promise((resolve, reject) => {
      resolve(mock.getUser)
    })
  } else {
    const req = {
      url: '/api/diligencias/cambiarestadodiligencias',
      method: 'PUT',
      headers: {
        'Content-type': 'application/json',
        'access-control-allow-origin': '*'
      },
      data: payload
    }
    const res = await axiosInstance(req)
    return res.data
  }
}

export { cambiarestadodiligencias }
